<template>
  <div class="media-uploader">
    <div class="uploader-content fit-content overflow-auto">
      <div class="media-header">
        <div>
          <h1 class="d-flex justify-content-start align-items-center">
            <span>Select date &amp; time</span>
          </h1>
        </div>
        <button class="btn-close" @click="close">&times;</button>
      </div>
      <div class="media-container p-4 overflow-hidden">
        <v-date-picker
          class="d-block mx-auto"
          :value="selectedDate"
          mode="dateTime"
          trim-weeks
          @input="dateInputChange"
        />
      </div>
      <div class="media-footer">
        <button class="btn btn-outline-secondary btn-sm" @click="close">
          Cancel
        </button>
        <button class="btn btn-info btn-sm" @click="dateSelected">Apply</button>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "media-uploader",
  props: ["date"],
  data() {
    return {
      selectedDate: null,
    };
  },
  methods: {
    dateInputChange(e) {
      this.selectedDate = e;
    },
    dateSelected() {
      if (this.selectedDate === null) {
        Swal.fire("", "Please select valid date", "warning");
      } else {
        this.$emit("close", this.selectedDate);
      }
    },
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    this.selectedDate = this.date;
  },
};
</script>